(function () {
  function tabName(el) {
    return el.getAttribute("data-mayekoo-tab") || el.getAttribute("data-tab") || "";
  }

  function panelName(el) {
    return el.getAttribute("data-mayekoo-tabpanel") || el.getAttribute("data-tabpanel") || "";
  }

  function initWidget(root) {
    if (root.dataset.mayekooTabsBound === "1") return;
    root.dataset.mayekooTabsBound = "1";

    var tabsRoot = root.querySelector("[data-mayekoo-tabs], [data-tabs]");
    if (!tabsRoot) return;

    var tabButtons = tabsRoot.querySelectorAll("[data-mayekoo-tab], [data-tab]");
    var panels = tabsRoot.querySelectorAll("[data-mayekoo-tabpanel], [data-tabpanel]");

    function activate(name) {
      tabButtons.forEach(function (button) {
        var active = tabName(button) === name;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
        button.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var active = panelName(panel) === name;
        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
        panel.setAttribute("aria-hidden", active ? "false" : "true");
      });
    }

    tabsRoot.addEventListener(
      "click",
      function (event) {
        var button = event.target.closest("[data-mayekoo-tab], [data-tab]");
        if (!button || !tabsRoot.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
        activate(tabName(button));
      },
      true,
    );
  }

  function initAll() {
    document.querySelectorAll("[data-mayekoo-fundraiser]").forEach(initWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
  window.addEventListener("load", initAll);

  if (typeof MutationObserver !== "undefined") {
    var observer = new MutationObserver(function () {
      initAll();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
